import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"
import { MdOutlineCheck, MdOutlineClose } from "react-icons/md"
import { CardButton } from "../../../../../../components/button-favorite/styles"

export const ActionCard = (props: any): JSX.Element => {
    const { message, show, setChange} = props

    const changeMode = (mode: any) => {
        setChange(mode);
    }

    return (
        <>
            {
                show ? (
                    <div className="d-flex justify-content-end">
                        <CardButton>
                            <OverlayTrigger placement={'top'} overlay={<Tooltip>Salvar Alterações</Tooltip>}>
                                <button type="submit" className="btn">
                                    <MdOutlineCheck style={{ fontSize: '24px' }} />
                                </button>
                            </OverlayTrigger>

                            <OverlayTrigger placement={'top'} overlay={<Tooltip>Cancelar</Tooltip>}>
                                <button type="button" className="btn">
                                    <MdOutlineClose style={{ fontSize: '24px' }} onClick={() => changeMode(false)} />
                                </button>
                            </OverlayTrigger>
                        </CardButton>
                    </div>
                ) : (
                    <Button variant="link" style={{ textDecoration: 'none' }} onClick={() => changeMode(true)}>{ message }</Button>
                )
            }
        </>

    )
}